import React, {memo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {AppModal, Col, UiBox, UiButton, UiSimpleGrid, UiText} from '~/components/elements';
import {
  BIRTH_CONTROL_REFILL_KEYS,
  METHOD_KEYS,
  SPEAK_TO_CARE_TEAM_LINK,
  SPEAK_TO_CARE_TEAM_DEEPLINK,
} from '~/constants/medical-questionnaires';
import {Action} from '~/redux/questionnaires/types';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {getCurrentUserFromStorage} from '~/services/auth';
import {triggerChat} from '~/utils/helpers';
import {spacing} from '~/utils/theme/spacing';

interface Props {
  isShowing: boolean;
  onDismissModal: () => void;
}

const PROCEED = 'PROCEED';
const SPEAK_WITH_CARE_TEAM = 'SPEAK_WITH_CARE_TEAM';

const PurchaseNotFoundModal = ({isShowing, onDismissModal}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();

  const {accessToken: savedToken} = getCurrentUserFromStorage();

  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const isWebview = useSelector((state: RootState) => state.questionnaires.isWebview);

  const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = questionnaires?.find(i => i.key === BIRTH_CONTROL_REFILL_KEYS.PURCHASE_NOT_FOUND);

  const actions = questionnaire?.actions;

  const onCloseModal = () => {
    onDismissModal();
  };

  const onClickOption = (
    value: string,
    action: {
      value: string;
      params: any;
    },
  ) => {
    switch (value) {
      case PROCEED:
        history.push(
          `/?methodKey=${action?.value || METHOD_KEYS.BIRTH_CONTROL_REQUEST}&token=${savedToken}${
            isWebview ? '&isWebview=true' : ''
          }`,
        );
        history.go(0);
        break;
      case SPEAK_WITH_CARE_TEAM:
        if (isWebview) {
          window.open(SPEAK_TO_CARE_TEAM_DEEPLINK, '_self');
        } else {
          triggerChat();
        }

        break;
      default:
        break;
    }
  };

  return !isShowing ? null : (
    <AppModal actions={null} isOpen={isShowing} onClose={onCloseModal} contentMinW="40%" isCentered size="lg">
      <Col alignItems="center" textAlign="center">
        <UiText fontSize="md" fontWeight="bold" mt={spacing.tiny}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.descriptions?.default?.map(i => (
          <UiText key={i} fontSize="sm" mt={spacing.small}>
            {i}
          </UiText>
        ))}
        <UiBox w="65%" mt={spacing.medium}>
          <UiSimpleGrid columns={1} spacing={actions && actions?.length > 1 ? 5 : 0} width="100%">
            {actions?.map(item => (
              <UiButton
                key={item.value}
                title={item.label}
                minW="150px"
                height={spacing.medium}
                variant={item.value === SPEAK_WITH_CARE_TEAM ? 'outline' : 'primary'}
                _hover={{
                  background: 'baseColor',
                  color: 'white',
                }}
                onClick={() => onClickOption(item.value, item.userAction)}
              />
            ))}
          </UiSimpleGrid>
        </UiBox>
      </Col>
    </AppModal>
  );
};

export default memo(PurchaseNotFoundModal);
